import { createContext, useContext, useEffect, useState } from 'react';

const AuthContext = createContext(null as any);

export function AuthProvider({ children }) {
	const authState = useState({
		user: null,
	});

	return <AuthContext.Provider value={authState}>{children}</AuthContext.Provider>;
}

export function useAuth() {
	const [auth, setAuth] = useContext(AuthContext);

	function setUser(user) {
		setAuth({ user });
	}

	function clearUser() {
		if (auth.user) {
			setAuth({
				user: null,
			});
		}
	}

	return {
		user: auth.user,

		setUser,
		clearUser,
	};
}

export default AuthContext;
